/* Libs */
import styled from 'styled-components';


export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 710px;
  margin:0 auto;
`;
